import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setMembershipStatus } from "./redux/authSlice"; 
import { handleAPIRequest } from "./api/api";

const useMembershipStatus = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, token } = useSelector((state) => state.auth);

  useEffect(() => {
    const fetchMembershipStatus = async () => {
      try {
        if (isAuthenticated) {
          const response = await handleAPIRequest("get", "check-status", null,null, token);
          dispatch(setMembershipStatus(response.membershipStatus));
        }
      } catch (error) {
        console.error("Error fetching membership status:", error);
      }
    };

    fetchMembershipStatus();
  }, [isAuthenticated, token, dispatch]); // Re-run when authentication state changes
};

export default useMembershipStatus;
